import React from 'react'
import projectdata from "../assets/project.json"
import  Projectcard  from "../components/projectcard";

export default function project() {
  return (
    <div className='min-h-screen flex flex-col justify-center items-center px-4 py-16'>
      <div className='max-w-7xl w-full'>
        <h1 className='text-5xl md:text-6xl font-bold text-center mb-4 gradient-text'>Projects</h1>
        <p className='text-lg md:text-xl text-center text-white/70 mb-12 max-w-2xl mx-auto'>
          Here are some projects of mine.
        </p>
        
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
          {
            projectdata.map((proj, index) => (
              <Projectcard key={index} pimage={proj.pimage} ptitle={proj.ptitle} pdesc={proj.pdesc} plink={proj.plink}/>  
            ))
          }
        </div>
      </div>
    </div>
  )
}
